import { APIModel } from './api-model.model'

export class APIMenuItem extends APIModel {
    menuId: number;
    menuItemId: number;
    menuItemTitle: string ;
    menuItemIcon: string;
    menuItemExtraClasses: string;
    menuItemParentId?: number;
    childItems?: APIMenuItem[];
    menuItemPriority: number;
    menuItemUrl: string ;
    permissionId: number;
    menuItemEnabled: number;

    constructor (params: {
        id?: number;
        createdAt?: string;
        updatedAt?: string;
        deletedAt?: string;
        menuId: number;
        menuItemId: number;
        menuItemTitle: string ;
        menuItemIcon: string;
        menuItemExtraClasses: string;
        menuItemParentId?: number;
        childItems?: APIMenuItem[];
        menuItemPriority: number;
        menuItemUrl: string;
        permissionId: number;
        menuItemEnabled: number;
    }) {
        const { id, createdAt, updatedAt, deletedAt } = params
        super({ id, createdAt, updatedAt, deletedAt })

        this.menuId = params.menuId
        this.menuItemId = params.menuItemId
        this.menuItemTitle = params.menuItemTitle
        this.menuItemIcon = params.menuItemIcon
        this.menuItemExtraClasses = params.menuItemExtraClasses
        this.menuItemParentId = params.menuItemParentId
        this.childItems = params.childItems
        this.menuItemPriority = params.menuItemPriority
        if (typeof params.menuItemPriority === 'string') this.menuItemPriority = parseInt(params.menuItemPriority)
        this.menuItemUrl = params.menuItemUrl
        this.permissionId = params.permissionId
        this.menuItemEnabled = params.menuItemEnabled ? 1 : 0
    }
}
